import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.82);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 100000;
  animation: ${fadeIn} 140ms ease-out;
  padding: 24px;
`;

export const TopBar = styled.div`
  position: fixed;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1;
`;

export const FileName = styled.div`
  color: #fff;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  max-width: 40vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const IconBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.22);
  }
`;

export const ImageWrap = styled.div`
  max-width: 92vw;
  max-height: 88vh;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 88vh;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  }
`;

export const PdfPanel = styled.div`
  width: min(960px, 96vw);
  height: min(86vh, 900px);
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
`;

export const PdfHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: #1f2937;
  color: #fff;

  ${FileName} {
    background: transparent;
    padding: 0;
    color: #fff;
    max-width: unset;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const PdfBody = styled.div`
  flex: 1;
  position: relative;
  background: #525659;

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export const Loading = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: Inter;
  font-size: 14px;
  pointer-events: none;
`;
